import { PasswordInput, Stack } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

interface PasswordConfirmationInputProps<T extends { password: any; passwordConfirmation: any }> {
  form: UseFormReturnType<T>;
}

export function PasswordConfirmationInput<T extends { password: any; passwordConfirmation: any }>({
  form,
}: PasswordConfirmationInputProps<T>) {
  const handlePasswordChange = (value: string) => {
    form.setFieldValue("password" as keyof T, value as any);
    // Trigger validation on both fields
    form.validateField("password");
    form.validateField("passwordConfirmation");
  };

  const handlePasswordConfirmationChange = (value: string) => {
    form.setFieldValue("passwordConfirmation" as keyof T, value as any);
    // Trigger validation on both fields
    form.validateField("password");
    form.validateField("passwordConfirmation");
  };

  return (
    <Stack>
      <PasswordInput
        placeholder="비밀번호"
        value={form.values.password}
        error={form.errors.password}
        onChange={(event) => handlePasswordChange(event.currentTarget.value)}
      />
      <PasswordInput
        placeholder="비밀번호 확인"
        value={form.values.passwordConfirmation}
        error={form.errors.passwordConfirmation}
        onChange={(event) => handlePasswordConfirmationChange(event.currentTarget.value)}
      />
    </Stack>
  );
}
